export default "__VITE_ASSET__CBC6r43q__"